<template>
  <div style="height: 100%">
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%; width: 100%">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="建筑物名称">
                <el-input
                  v-model="form.buildingName"
                  clearable
                  placeholder="请输入"
                  size="small"
                ></el-input>
              </el-form-item>
              <el-form-item label="所属社区">
                <el-select
                  v-model="form.pointLevelIdList"
                  multiple
                  collapse-tags
                  filterable
                  placeholder="请选择">
                  <el-option
                    v-for="item in actionsOne"
                    :key="item.deptCode"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="建筑物类型">
                <el-select
                  filterable
                  placeholder="请选择"
                  v-model="form.buildingType"
                  size="small"
                >
                  <el-option
                    v-for="item in jzwList"
                    :key="item. id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="责任社工">
                <el-input
                  v-model="form.typeWorker"
                  clearable
                  placeholder="请输入"
                  size="small"
                ></el-input>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button @click="onSearch" size="small" class="button-primary">查询</el-button>
                <el-button class="reset" size="small" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <div style="display: flex;align-items: center;margin-bottom: 10px;">
          <el-button type="primary" icon="el-icon-plus" plain @click="addJzw" class="button-primary" size="small">新增建筑物</el-button>
          <el-button type="primary" icon="el-icon-download" plain @click="downloadTemp" class="button-primary" size="small">模板下载</el-button>
          <el-upload
            class="upload-demo"
            accept=".xlsx"
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="importData"
          >
            <el-button type="primary" icon="el-icon-upload" class="button-primary ml-10" :loading="importLoading" size="small">上传建筑物</el-button>
          </el-upload>
          <el-button type="primary" icon="el-icon-upload2" plain @click="exportData" class="button-primary ml-10" size="small" :loading="exportLoading">导出</el-button>
        </div>
        <common-table
          :page="page"
          :dataList="dataList"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :maxHeight="540"
        >
          <template v-slot:buildingType="{ scope }">
            <span>{{ jzwListValue[scope.row.buildingType] }}</span>
          </template>
          <template v-slot:operation="{ scope }">
            <el-button
              @click="editRow(scope.row)"
              style="font-size: 16px"
              type="text"
              >编辑</el-button
            >
            <el-button
              @click="delRow(scope.row)"
              style="font-size: 16px;color: red;"
              type="text"

              >删除</el-button
            >
          </template>
        </common-table>
      </div>
    </div>
    <!-- 编辑人员 -->
    <el-dialog
      :title="formInline && formInline.id ? '编辑建筑物' : '新增建筑物'"
      :visible.sync="dialogVisible"
      width="500px"
      :modal="true"
      :close-on-click-modal="false"
    >
      <div class="container-dialog">
        <el-form
          :model="formInline"
          ref="form"
          label-width="120px"
          :rules="rules"
        >
          <el-form-item label="建筑物所属社区" prop="pointName">
            <el-select
              v-model="formInline.pointName"
              filterable
              placeholder="请选择">
              <el-option
                v-for="item in actionsOne"
                :key="item.deptCode"
                :label="item.text"
                :value="item.text">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="建筑物名称" prop="buildingName">
            <el-input
              v-model="formInline.buildingName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="建筑类型" prop="buildingType">
            <el-select
              filterable
              placeholder="请选择"
              v-model="formInline.buildingType"
            >
              <el-option
                v-for="item in jzwList"
                :key="item. id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="责任社工">
            <el-input
              v-model="formInline.typeWorker"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input
              v-model="formInline.typeWorkerPhone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="editFun" class="button-info">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  buildingpage,
  buildingsave,
  buildingupdate,
  buildingdelete,
  buildingexport,
  buildingimport,
} from "@/api/base.js";
import {
  getCommcommunityAll,
} from "@/api/point.js";
import commonTable from "@/components/table/index.vue";
import { downloadFile } from "@/api/systemManagement.js";
export default {
  components: {
    commonTable
  },
  data() {
    return {
      // 编辑人员弹窗
      actionsOne: [],
      dialogVisible: false,
      formInline: {
        pointName: "",
        buildingName: "",
        buildingType: "",
        typeWorker: "",
        typeWorkerPhone: "",
      },
      rules: {
        pointName: [{ required: true, message: "请选择社区", trigger: "blur" }],
        buildingName: [{ required: true, message: "请输入建筑物名称", trigger: "blur" }],
        buildingType: [{ required: true, message: "请选择建筑类型", trigger: "blur" }],
      },
      jzwList: [
        {
          name: '高层公共建筑',
          id: 1
        },
        {
          name: '多层建筑',
          id: 2
        },
        {
          name: '高层建筑（建筑高度大于27米）',
          id: 3
        },
        {
          name: '单层建筑',
          id: 4
        },
      ],
      jzwListValue: {
        1: '高层公共建筑',
        2: '多层建筑',
        3: '高层建筑（建筑高度大于27米）',
        4: '单层建筑',
      },
      loading: false,
      // 标签管理
      dialogTableVisible: false,
      exportLoading: false,
      importLoading: false,
      form: {
        buildingName: "",
        buildingType: "",
        pointLevelIdList: [],
        typeWorker: "",
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "pointName",
            label: "所属社区",
          },
          {
            prop: "buildingName",
            label: "建筑物名称"
          },
          {
            slot: "buildingType",
            label: "建筑类型",
          },
          {
            prop: "typeWorker",
            label: "责任社工",
          },
          {
            prop: "typeWorkerPhone",
            label: "联系电话",
            width: '200px'
          },
          {
            slot: "operation",
            label: "操作",
          }
        ]
      },
    };
  },
  mounted() {
    this.getmySqDept();
  },
  methods: {
    // 社区数据
    async getmySqDept () {
      let res = await getCommcommunityAll();
      if (res.data.code == 200) {
        let actionsData = res.data.data.map((item) => ({
          value: item.id,
          text: item.pointName,
          deptCode: item.deptCode,
        }));
        let detpCode = JSON.parse(
          sessionStorage.getItem("userInfo")
        ).detpCode;
        // let detpCode = "4403260050232323";
        this.form.pointLevelIdList = [];
        if (detpCode.length < 12) {
          this.actionsOne = JSON.parse(JSON.stringify(actionsData));
        } else {
          let code = detpCode.slice(0, 12);
          this.actionsOne = actionsData.filter(
            (item) => item.deptCode == code
          );
          if (this.actionsOne.length) {
            this.form.pointLevelIdList.push(this.actionsOne[0].value)
            // this.form.sq = this.actionsOne[0].value;
          }
          else {
            this.actionsOne = JSON.parse(JSON.stringify(actionsData));
          }
        }
        this.getPointTypeListPageFun(1);
      }
    },
    // 下载模板
    async downloadTemp () {
      const res = await downloadFile({
        filePath: "/template/建筑信息导入模板.xlsx"
      });
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "建筑信息导入模板.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },

    // 导出数据
    async exportData () {
      this.exportLoading = true;
      const params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size,
      };
      const res = await buildingexport(params);
      console.log("res :>> ", res);
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "建筑信息数据.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
          this.exportLoading = false;
        } catch (err) {
          console.log(err);
          this.exportLoading = false;
        }
      };
      fileReader.readAsText(res.data);
      this.exportLoading = false;
    },

    // 导入数据
    async importData(file) {
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      this.importLoading = true;
      let formData = new FormData();
      formData.append("file", file.raw);
      const res = await buildingimport(formData);
      if (res.data.code == 200 && !res.data.data.filePath) {
        this.$message({
          message: `导入成功：${res.data.data.msg}`,
          type: "success"
        });
        this.onSearch();
      } else if (res.data.code == 200 && res.data.data.filePath) {
        this.$message({
          message: `导入失败：${res.data.data.msg}`,
          type: "error"
        });
        this.onSearch();

        let resFile = await downloadFile({
          filePath: res.data.data.relativePath
        });
        let fileReader = new FileReader();
        fileReader.onload = function() {
          try {
            if (resFile.code == 300) {
              // 说明是普通对象数据，后台转换失败
              // proxy.MSG.error(resFile.message);
              return;
            } else {
              // 解析成对象失败，说明是正常的文件流
              let url = window.URL.createObjectURL(new Blob([resFile.data]));
              let link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.target = "_blank";
              link.setAttribute("download", `${res.data.data.fileName}`);
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
              document.body.removeChild(link);
            }
          } catch (err) {
            console.log(err);
          }
        };
        fileReader.readAsText(resFile.data);
      } else {
        this.$message({
          message: '网络波动，请重新导入文件',
          type: "info"
        });
      }
      this.importLoading = false;
    },

    // 新增建筑物
    addJzw () {
      this.formInline = this.$options.data().formInline;
      this.dialogVisible = true;
    },

    // 编辑
    editRow (row) {
      this.formInline = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    // 编辑确认
    async editFun() {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      let params = {
        ...this.formInline,
        id: this.formInline.id || '',
        pointLevelId: this.actionsOne.find(item => item.text == this.formInline.pointName).value || '',
        deptCode: this.actionsOne.find(item => item.text == this.formInline.pointName).deptCode || '',
      };
      const res = await (this.formInline && this.formInline.id ? buildingupdate(params) : buildingsave(params))
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.dialogVisible = false;
        this.getPointTypeListPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    
    // 删除
    async delRow(row) {
      const isok = await this.$confirm("是否删除该数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => true)
        .catch(() => false);
      if (!isok) {
        return;
      }
      const res = await buildingdelete([
        row.id
      ]);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.getPointTypeListPageFun(1);
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun(1);
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.form = this.$options.data().form;
      this.page.page = 1;
      this.page.size = 10;
      this.getmySqDept();
    },
    // 分页查询
    async getPointTypeListPageFun(val) {
      if (val && val == 1) this.page.page = 1;
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size,
      };
      const res = await buildingpage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data ? (res.data.data.records
          ? res.data.data.records
          : []) : [];
        this.page.total = res.data ? res.data.data.total : 0;
      } else return this.$message.error(res.data.msg)
    },
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
/deep/ .button-primary {
  border-radius: 4px;
  padding: 0px 12px;
  background: #0495ff;
  font-family: MiSans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  color: #fff;
}
// /deep/ .button-danger {
//   border-radius: 4px;
//   padding: 0px 12px;
//   background: #fff;
//   font-family: MiSans;
//   font-size: 16px;
//   font-weight: normal;
//   line-height: normal;
//   color: red;
//   margin-right: 20px;
// }
/deep/ .button-info {
  background: #0054FE !important;
}
.box-father {
  background: #F1F4F6 !important;
  overflow: hidden !important;
}
.postImg {
  width: 98px;
  height: 48px;
  border-radius: 8px;
}

.caogao {
  color: #0054FE;
  background: rgba(0, 84, 254, 0.0966);
  border-radius: 4px;
  padding: 2px 15px;
}

.yifabu {
  color: #00AC94;
  background: rgba(0, 172, 148, 0.0966);
  border-radius: 4px;
  padding: 2px 15px;
}

.yxj {
  color: #8C949C;
  background: rgba(140, 148, 156, 0.0966);
  border-radius: 4px;
  padding: 2px 15px;
}

.cl-primary {
  color: #008cff;
}
.mr-40 {
  margin-right: 40px;
}
.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}

.fileJson {
  img {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

/deep/ .el-carousel__arrow {
  width: 54px !important;
  height: 54px !important;
  font-size: 18px !important;
}
.pass {
  color: #17b3ad;
}
.noPass {
  color: #ff5348;
}
.warin {
  color: #FFA200;
}
.box {
  display: flex;
}
.box-1 {
  flex: 1;
}
.box-2 {
  flex: 2;
}
.box-3 {
  flex: 3;
}
.box-7 {
  flex: 7;
}
.box-wrap {
  flex-wrap: wrap;
}
.box-column {
  flex-direction: column;
}
.box-column-center {
  align-items: center;
}
.box-center {
  justify-content: center;
}
.box-center {
  justify-content: center;
  align-items: center;
}
.box-between {
  justify-content: space-between;
}
.border-bottom {
  border-bottom: 1px solid #e4e4e4;
}
.p-15 {
  padding: 15px;
}
.pb-10 {
  padding-bottom: 10px;
}
.pb-20 {
  padding-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-10 {
  margin-right: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.bold {
  font-weight: bold;
}
.w100 {
  width: 130px;
}
.mb-10 {
  margin-bottom: 10px;
}
.pointer {
  cursor: pointer;
}
.mt-16 {
  margin-top: 16px;
}
.p-10 {
  padding: 10px;
}
.pt-10 {
  padding-top: 10px;
}
.pl-10 {
  padding-left: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.pb-10 {
  padding-bottom: 10px;
}
.dialog-body {
  .item {
    height: 500px;
    overflow: auto;
    border-radius: 4px;
    border: 1px solid #E0E0E0;
    .leftLabel {
      font-family: MiSans;
      font-size: 20px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0px;
      color: #494C4F;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/userManagement/jzwList.vue